import { IPendenciesRepository } from 'modules/customer/domain/repositories';
import { makeHTTPProvider } from 'shared/infra/providers';

import { VectisPendenciesRepository } from './implementations/VectisPendenciesRepository';

let instance: IPendenciesRepository | null = null;

export default function makePendenciesRepository() {
  if (!instance) {
    const httpProvider = makeHTTPProvider();

    instance = new VectisPendenciesRepository(httpProvider);
  }

  return instance;
}
